import React, { Component } from 'react'
import './css/SubmitForm.css'

class SubmitForm extends Component {
  constructor(props){
    super(props)

    this.state = {
      name: '',
      organisation: '',
      email: '',
      score: this.props.score
    }

  }

  handleChange(event){
    switch(event.target.getAttribute('name')){
      case 'name':
        this.setState({name: event.target.value})
        break
      case 'organisation':
        this.setState({organisation: event.target.value})
        break
      case 'email':
        console.log(event.target);
        this.setState({email: event.target.value})
        break
      default:

    }
    if(this.state.firstName && this.state.lastName && this.state.email){
      this.setState({validated: true})
    } else {
      this.setState({validated: false})
    }
  }

  handleSubmit(event){
    event.preventDefault()
    this.props.submitScore(this.state)
  }

  render(){
    return(
      <div className="SubmitFormWrap">
        <form className="SubmitForm animated zoomIn" onSubmit={this.handleSubmit.bind(this)}>
          <p className="scoreDisplay">Your score is <span>{this.state.score}</span></p>
          <p className="control">
            <input name="name" onChange={this.handleChange.bind(this)} className="input is-large" type="text" placeholder="Name" value={this.state.firstName}/>
          </p>
          <p className="control">
            <input name="organisation" onChange={this.handleChange.bind(this)} className="input is-large" type="text" placeholder="Organisation" value={this.state.lastName}/>
          </p>
          <p className="control">
            <input name="email" onChange={this.handleChange.bind(this)} className="input is-large" type="email" placeholder="Email" value={this.state.email}/>
          </p>
          <p className="control level is-full-width">
            <button type="reset" name="cancel" onClick={(event) => this.props.hideForm(event)} className="button is-large is-danger">Cancel</button>
            <button type="submit" name="submit" className="button is-large is-primary"
              disabled={this.state.name && this.state.organisation && this.state.email ? '' : 'disabled'}>
              Submit
            </button>
          </p>
        </form>
      </div>
    )
  }

}

export default SubmitForm



/** WEBPACK FOOTER **
 ** ./src/SubmitForm.js
 **/